// src/API/Config.js

const BASEURL = "https://apimiraclebaba.in";
// const BASEURL = "http://localhost:6006";



export default BASEURL;